import styled from "styled-components";
import Contact from "svg/contact";

export const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.palette.green};
  padding: 6rem 1.5rem;
  display: flex;
  flex-direction: column;

  ${props => props.theme.responsive.media.desktop} {
    padding: 3.7rem 4.7rem 9rem;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2.5rem;
  border-bottom: 2px solid black;

  ${props => props.theme.responsive.media.desktop} {
    justify-content: flex-start;
    gap: 1.5rem;
    padding-bottom: 3.7rem;
  }
`;

export const Title = styled.h1`
  font-family: ${props => props.theme.fonts.daysOne};
  font-size: 3rem;
  color: black;
  text-transform: uppercase;

  ${props => props.theme.responsive.media.desktop} {
    font-size: 6rem;
    line-height: 6.5rem;
  }
`;

export const Icon = styled(Contact)`
  height: 2rem;
  width: 2rem;

  ${props => props.theme.responsive.media.desktop} {
    height: 3.6rem;
    width: 3.6rem;
  }
`;

export const Email = styled.div`
  width: 100%;
  margin-top: 9rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & a {
    font-family: Arial;
    font-weight: 700;
    font-size: 3rem;
    text-decoration: underline;
    text-transform: uppercase;
    color: black;
  }

  ${props => props.theme.responsive.media.desktop} {
    margin-top: 17rem;
    width: 50%;
    align-self: flex-end;
  }
`;

export const Address = styled.div`
  width: auto;
  margin-top: 6rem;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & p {
    font-family: Arial;
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.6rem;
    letter-spacing: 0.03em;
    color: black;
  }

  ${props => props.theme.responsive.media.desktop} {
    margin-top: 8rem;
    width: 50%;
    align-self: flex-end;
  }
`;

export const Logo = styled.img`
  margin-top: 7rem;
  margin-right: 2rem;
  height: 4.5rem;
  width: 14.5rem;
  align-self: flex-end;

  ${props => props.theme.responsive.media.desktop} {
    margin: 0;
    height: 7.1rem;
    width: 22.9rem;
    position: absolute;
    left: 5rem;
    bottom: 9rem;
  }
`;

export const ScrollTop = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 7rem;
  margin-right: 4rem;

  ${props => props.theme.responsive.media.desktop} {
    margin: 0;
    position: absolute;
    right: 5rem;
    bottom: 9rem;
    flex-direction: column;
    gap: 2rem;

    & p {
      writing-mode: vertical-rl;
      text-orientation: mixed;
    }
  }
`;

export const Label = styled.p`
  font-family: Arial;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: black;
  opacity: 0.5;
  text-transform: uppercase;
`;

export const Button = styled.button`
  height: 3rem;
  width: 3rem;
  border-radius: 10rem;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
`;
